import { MOCK_PLUGIN_ID_PREFIX } from '../consts';
import { Env } from '../Env';
import { assert } from './assert';
export function formPurchaseBackendUrl(urlPath = '/') {
    const url = new URL(urlPath, Env.PURCHASE_BACKEND_URL);
    if (Env.isProduction()) {
        return url.toString();
    }
    const devGatewayUrl = new URL(urlPath, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? Env.DEV_PURCHASE_BACKEND_INSECURE_GATEWAY_PORT
        : Env.DEV_PURCHASE_BACKEND_SECURE_GATEWAY_PORT;
    devGatewayUrl.port = `${port}`;
    return devGatewayUrl.toString();
}
/**
 * The recording backend, and where recordings are read from. In
 * development both are the local backend (STORAGE=local), behind the
 * gateway that matches the page's protocol. Undefined when the deployment
 * has no recording backend.
 */
export function formRecordingUrls() {
    if (Env.isProduction()) {
        if (!Env.RECORDING_BACKEND_URL || !Env.RECORDING_STORAGE_URL) {
            return undefined;
        }
        return {
            backendUrl: Env.RECORDING_BACKEND_URL.replace(/\/$/, ''),
            storageUrl: Env.RECORDING_STORAGE_URL.replace(/\/$/, ''),
        };
    }
    if (Env.RECORDING_BACKEND_URL && Env.RECORDING_STORAGE_URL) {
        return {
            backendUrl: Env.RECORDING_BACKEND_URL.replace(/\/$/, ''),
            storageUrl: Env.RECORDING_STORAGE_URL.replace(/\/$/, ''),
        };
    }
    const gateway = new URL('/', window.location.href);
    gateway.port = `${gateway.protocol === 'http:'
        ? Env.DEV_RECORDING_BACKEND_INSECURE_GATEWAY_PORT
        : Env.DEV_RECORDING_BACKEND_SECURE_GATEWAY_PORT}`;
    const backendUrl = gateway.toString().replace(/\/$/, '');
    return { backendUrl, storageUrl: `${backendUrl}/local-storage` };
}
export function formPluginUrl(pluginId, urlPath = '/') {
    if (Env.isProduction()) {
        // TEST_PLUGINS (e.g. the tvtesting build) targets the -test plugin
        // deployments, whose CloudFront serves the CORP/COEP headers a
        // cross-origin-isolated parent requires for iframe embedding.
        const subdomain = Env.TEST_PLUGINS ? `${pluginId}-test` : pluginId;
        return new URL(urlPath, `https://${subdomain}.streamrtvplugins.com`).toString();
    }
    if (pluginId.startsWith(MOCK_PLUGIN_ID_PREFIX)) {
        return formMockPluginUrl(pluginId, urlPath);
    }
    if (pluginId !== 'chat') {
        throw new Error(`Unknown plugin id: ${pluginId}`);
    }
    const devGatewayUrl = new URL(urlPath, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? Env.DEV_CHAT_INSECURE_GATEWAY_PORT
        : Env.DEV_CHAT_SECURE_GATEWAY_PORT;
    devGatewayUrl.port = `${port}`;
    return devGatewayUrl.toString();
}
function formMockPluginUrl(pluginId, urlPath = '/') {
    assert(!Env.isProduction(), 'Mock plugins are only available in development');
    const devGatewayUrl = new URL(`/${pluginId}${urlPath}`, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? Env.DEV_MOCK_PLUGIN_INSECURE_GATEWAY
        : Env.DEV_MOCK_PLUGIN_SECURE_GATEWAY;
    devGatewayUrl.port = port;
    return devGatewayUrl.toString();
}
